









































































































































import { Component, Watch, Prop } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { DepositAccountModule } from '@/store/Accounts/DepositAccountModule';
import { InstitutionAccountModule } from '@/store/Accounts/InstitutionAccountModule';
import { AuthModule } from '@/store/Auth/AuthModule';
import CreatePayeeRequest from '@/models/Accounts/Shared/Payees/CreatePayeeRequest';
import ListUtils from '@/lib/listUtils';
import ProductType from "@/models/Products/ProductType";
import PayeeType from '@/models/Accounts/Shared/Payees/PayeeType';

@Component({ name: 'PayeeCreate' })
export default class extends SaascadaVueDialog {

    @Prop({required: true})
    accountId: string;

    @Prop({required: true})
    isCustomerAccount: boolean;

    @Prop({required: true})
    productType: ProductType;

    dialog = false;
    request: CreatePayeeRequest = new CreatePayeeRequest();
    PayeeType = PayeeType

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.request = new CreatePayeeRequest();
            // If there is only one payeeType available then set it by default
            if (this.payeeTypes.length === 1) {
                this.request.payeeType = this.payeeTypes[0];
            }
        }
    }

    get payeeTypes() {
        // TODO: This is currently taken from the go backend hardcoded field for AvailablePayeeTypes
        // But once this has been added to the main config the function can be swapped for just "institution.availablePayeeTypes"
        return AuthModule.me.institution.config.availablePayeeTypes;
    }

    get countryOptions() {
        return ListUtils.countryOptions();
    }

    get morePayeesAreAllowed() {
        // This scenario only applies to customer accounts
        if (this.isCustomerAccount) {
            if (this.productType === ProductType.Deposit) {
                // Check the current amount of Payees against the maximum allowed
                const depositAccountPayees = DepositAccountModule.payees;
                const depositAccountSettings = DepositAccountModule.depositAccount.accountSettings;
                if (depositAccountSettings.generalPayeeSettings && depositAccountSettings.generalPayeeSettings.restrictNumberOfPayees) {
                    const maximumNumberOfPayees = DepositAccountModule.depositAccount.accountSettings.generalPayeeSettings.maximumNumberOfPayees;
                    return maximumNumberOfPayees > depositAccountPayees.length;
                }
            }
            else {
                return true;
            }
        }
        // Otherwise more payees are allowed
        return true;
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;
            this.request.accountId = this.accountId;

            if (this.isCustomerAccount) {
                if (this.productType === ProductType.Deposit) {
                    await DepositAccountModule.createPayee(this.request);
                    await DepositAccountModule.getPayees(1);
                }
            }
            else {
                await InstitutionAccountModule.createPayee(this.request);
                await InstitutionAccountModule.getPayees({ id: this.accountId, pageNumber: 1 });
            }
        }
    }

}
